import { BufferAttribute, BufferGeometry, Color, DoubleSide, Line, LineBasicMaterial, Mesh, MeshBasicMaterial, PlaneGeometry, Vector3, } from "three";
import { SceneGraphNode } from "../internal";
/**
 * PanoramaFrameFeatureBox - for drawing boexli's on panorama callote
 *
 * @class PanoramaFrameFeatureBox
 * @param {SceneGraphNode} parentNode
 * @extends {SceneGraphNode}
 * @constructor
 */
export class PanoFrameFeatureBox extends SceneGraphNode {
    constructor(nx, ny, w, h, calloteId) {
        super(null);
        this._nx = -1;
        this._ny = -1;
        this._w = -1;
        this._h = -1;
        this._zoom = -1;
        this.calloteId = -1;
        this.upperleft = null;
        this.upperright = null;
        this.lowerleft = null;
        this.lowerright = null;
        this._nx = nx;
        this._ny = ny;
        this._w = w;
        this._h = h;
        this.calloteId = calloteId;
        this._originalColor = new Color(parseInt("0xff0000"));
        this._highlightColor = new Color(parseInt("0x00ff00"));
        this.tMaterial = new MeshBasicMaterial({
            transparent: true,
            color: this._originalColor,
            opacity: 0.2,
            side: DoubleSide,
            depthTest: false,
            depthWrite: false,
        });
        this.geometry = new PlaneGeometry(1, 1, 1, 1);
        this.iMesh = new Mesh(this.geometry, this.tMaterial);
        const borderGeometry = new BufferGeometry();
        borderGeometry.setFromPoints([
            new Vector3(-0.5, 0.5, 0),
            new Vector3(0.5, 0.5, 0),
            new Vector3(0.5, -0.5, 0),
            new Vector3(-0.5, -0.5, 0),
            new Vector3(-0.5, 0.5, 0),
        ]);
        borderGeometry.computeBoundingSphere();
        const borderMaterial = new LineBasicMaterial({
            transparent: true,
            color: 0xff0000,
            opacity: 1.0,
            side: DoubleSide,
            depthTest: false,
            depthWrite: false,
        });
        this.iBorder = new Line(borderGeometry, borderMaterial);
    }
    render(traversalState) {
        super.render(traversalState);
        if (this.upperleft == null)
            this.update();
    }
    resize(nx, ny, w, h) {
        this._nx = nx;
        this._ny = ny;
        this._w = w;
        this._h = h;
        this.update();
    }
    destroy() {
        this.tMaterial = null;
        this.iMesh = null;
        this.iBorder = null;
        this._nx = null;
        this._ny = null;
        this._w = null;
        this._h = null;
        this._zoom = null;
    }
    show() {
        this.iMesh.visible = true;
        this.iBorder.visible = true;
    }
    hide() {
        this.iMesh.visible = false;
        this.iBorder.visible = false;
    }
    isVisible() {
        return this.iMesh.visible;
    }
    pick(mx, my) {
        if (this.initialized)
            return this.currentTraversalState.rayCaster.intersectObject(this.iMesh);
        return [];
    }
    highlightOn() {
        this.tMaterial["color"] = this._highlightColor;
    }
    highlightOff() {
        this.tMaterial["color"] = this._originalColor;
    }
    update() {
        if (this.initialized) {
            this.upperleft = this.currentTraversalState.actualQuadtree.mapTo3D(this._nx, this._ny, this.calloteId);
            this.upperright = this.currentTraversalState.actualQuadtree.mapTo3D(this._nx + this._w, this._ny, this.calloteId);
            this.lowerright = this.currentTraversalState.actualQuadtree.mapTo3D(this._nx + this._w, this._ny + this._h, this.calloteId);
            this.lowerleft = this.currentTraversalState.actualQuadtree.mapTo3D(this._nx, this._ny + this._h, this.calloteId);
            const positions = [];
            positions[0] = this.upperleft.x;
            positions[1] = this.upperleft.y;
            positions[2] = this.upperleft.z;
            positions[3] = this.upperright.x;
            positions[4] = this.upperright.y;
            positions[5] = this.upperright.z;
            positions[9] = this.lowerright.x;
            positions[10] = this.lowerright.y;
            positions[11] = this.lowerright.z;
            positions[6] = this.lowerleft.x;
            positions[7] = this.lowerleft.y;
            positions[8] = this.lowerleft.z;
            this.geometry.setAttribute("position", new BufferAttribute(new Float32Array(positions), 3));
            this.geometry.computeBoundingSphere();
            const borderGeometry = new BufferGeometry();
            borderGeometry.setFromPoints([
                this.upperleft,
                this.upperright,
                this.lowerright,
                this.lowerleft,
                this.upperleft,
            ]);
            borderGeometry.computeBoundingSphere();
            this.iBorder.geometry = borderGeometry;
        }
    }
    updateStyle(matdef) {
        if (matdef["polygon"]["fill"]) {
            if (matdef["polygon"]["fill"]["color"]) {
                this._originalColor = new Color(matdef["polygon"]["fill"]["color"]);
                this.tMaterial["color"] = this._originalColor;
            }
            if (matdef["polygon"]["fill"]["alpha"])
                this.tMaterial["opacity"] = matdef["polygon"]["fill"]["alpha"];
        }
        if (matdef["polygon"]["stroke"]) {
            if (matdef["polygon"]["stroke"]["color"]) {
                this.iBorder.material["color"] = new Color(matdef["polygon"]["stroke"]["color"]);
            }
            if (matdef["polygon"]["stroke"]["alpha"]) {
                this.iBorder.material["opacity"] = matdef["polygon"]["stroke"]["alpha"];
            }
            if (matdef["polygon"]["stroke"]["width"]) {
                this.iBorder.material["linewidth"] = matdef["polygon"]["stroke"]["width"];
            }
        }
        if (matdef["line"]["stroke"]) {
            if (matdef["line"]["stroke"]["color"]) {
                this.iBorder.material["color"] = new Color(matdef["line"]["stroke"]["color"]);
            }
            if (matdef["line"]["stroke"]["alpha"]) {
                this.iBorder.material["opacity"] = matdef["line"]["stroke"]["alpha"];
            }
            if (matdef["line"]["stroke"]["width"]) {
                this.iBorder.material["linewidth"] = matdef["line"]["stroke"]["width"];
            }
        }
    }
}
//# sourceMappingURL=panoframefeaturebox.js.map